import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import BlogCard from '../BlogCard';
const Section = t0 => {
  const $ = _c(16);
  const {
    category,
    posts,
    onReadAllClick
  } = t0;
  let t1;
  if ($[0] !== category.text) {
    t1 = <h2 className="text-3xl font-bold mt-0 mx-0 mb-[1em]">{category.text}</h2>;
    $[0] = category.text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== posts) {
    t2 = posts.map(_temp);
    $[2] = posts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-wrap box-border w-[calc(100%_+_24px)] -m-3">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== category.slug || $[7] !== onReadAllClick) {
    t4 = () => onReadAllClick(category.slug);
    $[6] = category.slug;
    $[7] = onReadAllClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== category.text || $[10] !== t4) {
    t5 = <div className="mt-10 inline-block lg:mt-[60px] lg:mb-5"><CtaButton styling="outline-button" color="brand" block={true} onClick={t4}>Read All {category.text}</CtaButton></div>;
    $[9] = category.text;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = <section className="relative p-10 [border-bottom:1px_solid_#f1f1f1] first:p-8 first:[border-top:1px_solid_#f1f1f1] last:[border-bottom:none] [&_.infinite-scroll-component]:!overflow-hidden">{t1}{t3}{t5}</section>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
Section.propTypes = {
  category: PropTypes.objectOf(PropTypes.object).isRequired,
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReadAllClick: PropTypes.func
};
export default Section;
function _temp(post) {
  return <div key={post.slug} className="mt-0 mx-0 mb-4 box-border p-3 flex-grow-0 max-w-full basis-full min-[600px]:max-w-[50%] min-[600px]:basis-1/2"><BlogCard post={post} key={post.slug} /></div>;
}